import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Heart = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M32.187 3.26c-3.153 0-6.117 1.23-8.34 3.454l-1.86 1.871-1.858-1.858a11.725 11.725 0 0 0-8.34-3.455c-3.154 0-6.118 1.231-8.341 3.455-4.597 4.597-4.597 12.083 0 16.693l17.886 17.886a.932.932 0 0 0 .666.276.932.932 0 0 0 .666-.276L40.552 23.42c4.597-4.598 4.597-12.084 0-16.693C38.304 4.49 35.34 3.26 32.187 3.26Zm7.021 18.816-17.22 17.22-17.221-17.22c-3.869-3.869-3.869-10.162 0-14.03a9.881 9.881 0 0 1 7.009-2.902c2.537 0 5.074.967 7.009 2.901l2.524 2.525a.948.948 0 0 0 1.332 0l2.524-2.525c3.869-3.868 10.162-3.868 14.018 0 3.894 3.87 3.894 10.162.025 14.03Z"
  }));
});
Heart.displayName = 'Heart';
Heart.defaultProps = {
  'aria-label': 'Heart'
};
export default Heart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Heart.js
// module id = 3184
// module chunks = 11